import { FormattedHTMLMessage, injectIntl } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import {
  type FormFieldComponentProps,
  type VerificationServiceProps,
  type Organization,
} from "../../../lib/types/types";
import { getOptions } from "../../../options/options";
import { FormFieldTypeahead } from "../FormFieldTypeahead/FormFieldTypeahead";
import { getOrgSearchUrl } from "../../../lib/ProgramTheme/programThemeGetters";

export const CollegeName = ({
  value,
  isErrored,
  onChange,
  verificationService,
  intl,
  placeholder = "",
  isRequired = true,
  disabled = false,
}: FormFieldComponentProps<Organization> & VerificationServiceProps) => {
  const urlAddSchoolForm = (getOptions().urlAddSchoolForm || "").trim();

  const isFieldHidden = getFieldConfigByFieldId("organization")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldTypeahead
      fieldId="college-name"
      value={value}
      verificationService={verificationService}
      onChange={(choice: Organization) => onChange(choice)}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({
          id: "schoolNamePlaceholder",
          defaultMessage: "University / College name",
        })
      }
      label={<FormattedHTMLMessage id="schoolName" defaultMessage="University / College name" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidOrganization"
            defaultMessage="You must select an organization from the list"
          />
        )
      }
      isRequired={isRequired}
      showPlaceholderAndHideLabel={!!placeholder}
      orgSearchUrl={getOrgSearchUrl(
        verificationService.viewModel,
        verificationService.programTheme,
      )}
      urlAddSchoolForm={urlAddSchoolForm}
      disabled={disabled}
    />
  );
};

export const CollegeNameComponent = injectIntl(CollegeName);
